import { render } from "./participationActivity.vue?vue&type=template&id=60c9ecf2"
import script from "./participationActivity.vue?vue&type=script&lang=js"
export * from "./participationActivity.vue?vue&type=script&lang=js"

import "./participationActivity.vue?vue&type=style&index=0&id=60c9ecf2&lang=less"
script.render = render

export default script